import { Component, Input, Output, EventEmitter } from '@angular/core';

/**
 * Generated class for the PhcInputCounterComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'phc-input-counter',
  templateUrl: 'phc-input-counter.html'
})
export class PhcInputCounterComponent {

  val: number = 0;
  initVal: number = 0;
  @Input() min: number;
  @Input() max: number;
  @Input() step: number = 1;
  @Input() btnColor: string = 'primary';
  @Input() color: string = 'light';

  @Output()
  valueChange = new EventEmitter<number>();

  @Input()
  get value(){
    return this.val;
  }

  set value(val) {
    this.val = val;
    if(isNaN(val)){
      this.val = 0;
    }
    this.valueChange.emit(this.val);
  }

  constructor() {
    console.log('Hello PhcInputCounterComponent Component');
    this.initVal = this.value;
  }


  increment(){
    if (this.val + this.step > this.max) {
      return;
    }
    this.val = this.val + this.step;
    this.valueChange.emit(this.val);
  }

  decrement(){
    if (this.val - this.step < this.min) {
      return;
    }
    this.val = this.val - this.step;
    this.valueChange.emit(this.val);
  }

  reset(){
    this.val = this.initVal;
    this.valueChange.emit(this.val);
  }

}



// WEBPACK FOOTER //
// ./src/components/phc-input-counter/phc-input-counter.ts